import { MODAL_TITLE, PAGE_TITLE } from '@lessonPlanner/prompts';

import { PageKey } from '../enums/pageKey';

export const PAGE_KEY_TITLES = {
  [PageKey.lessonPlan]: { title: MODAL_TITLE.LP, pageTitle: PAGE_TITLE.LP },
  [PageKey.objective]: { title: MODAL_TITLE.LC, pageTitle: PAGE_TITLE.LC },
  [PageKey.quizMakerSingle]: {
    title: MODAL_TITLE.QMS,
    pageTitle: PAGE_TITLE.QMS,
  },
  [PageKey.activities]: { title: MODAL_TITLE.AC, pageTitle: PAGE_TITLE.AC },
  [PageKey.subjectExtention]: {
    title: MODAL_TITLE.SE,
    pageTitle: PAGE_TITLE.SE,
  },
  [PageKey.analogyContextualizer]: {
    title: MODAL_TITLE.ANLG,
    pageTitle: PAGE_TITLE.ANLG,
  },
  [PageKey.summativeTest]: {
    title: MODAL_TITLE.ST,
    pageTitle: PAGE_TITLE.ST,
  },
  [PageKey.cerebroLessonPlan]: {
    title: MODAL_TITLE.CLP,
    pageTitle: PAGE_TITLE.CLP,
  },
  [PageKey.dailyLessonLog]: {
    title: MODAL_TITLE.DLL,
    pageTitle: PAGE_TITLE.DLL,
  },
  [PageKey.catchUpFridays]: {
    title: MODAL_TITLE.CUF,
    pageTitle: PAGE_TITLE.CUF,
  },
  [PageKey.topicExplorer]: {
    title: MODAL_TITLE.TE,
    pageTitle: PAGE_TITLE.TE,
  },
  [PageKey.energizer]: {
    title: MODAL_TITLE.EN,
    pageTitle: PAGE_TITLE.EN,
  },
  [PageKey.elif]: {
    title: MODAL_TITLE.ELIF,
    pageTitle: PAGE_TITLE.ELIF,
  },
  [PageKey.photoBooth]: {
    title: MODAL_TITLE.PHOTO_BOOTH,
    pageTitle: PAGE_TITLE.PHOTO_BOOTH,
  },
  [PageKey.unitPlan]: {
    title: MODAL_TITLE.UP,
    pageTitle: PAGE_TITLE.UP,
  },
  [PageKey.pptMaker]: {
    title: MODAL_TITLE.PPT,
    pageTitle: PAGE_TITLE.PPT,
  },
  [PageKey.genericUnpacking]: {
    title: MODAL_TITLE.GU,
    pageTitle: PAGE_TITLE.GU,
  },
  [PageKey.iplan]: {
    title: MODAL_TITLE.IPLAN,
    pageTitle: PAGE_TITLE.IPLAN,
  },
  [PageKey.iplanObjective]: {
    title: MODAL_TITLE.IPLAN_OBJ,
    pageTitle: PAGE_TITLE.IPLAN_OBJ,
  },
  [PageKey.multigradeLessonPlan]: {
    title: MODAL_TITLE.MG,
    pageTitle: PAGE_TITLE.MG,
  },
};
